<template>
  <div id="container">
    <div class="fzf">
      <div class="fzfbox">
        <strong>{{title}}</strong>
        <div>{{text}}</div>

        <router-link class="break-btn" :to="{path:'/'}">
          Go to homepage!
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  components: {},
  data() {
    return {
      title: '404 ...',
      text: 'Looks like this page is missing.'
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {

  }
}
</script>
<style scoped>
.fzf {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 100px 50px;
}

.notfind {
  height: 450px;
}

.pay {
  height: auto;
  margin-top: 30%;
  margin-bottom: 20px;
}

.fzfbox {
  width: 100%;
  padding-top: 190px;
  text-align: center;
  background: url(../../../static/images/404.svg) center 0 no-repeat;
  font-size: 18px;
  line-height: 2;
}
.fzfbox strong {
  font-size: 28px;
}
.break-btn {
  display: inline-block;
  line-height: 32px;
  padding: 5px 15px;
  text-align: center;
  color: #fff;
  background: #5f6dae;
  border-radius: 4px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shared/404.vue